import { createObjectStorage, Storage, ObjectStorage } from 'infra/storage'

export interface LastWorkspace {
  [key: string]: string
}

/**
 * Special value to indicate "All workspaces" was explicitly selected.
 */
export const ALL_WORKSPACES_SELECTION = '__ALL_WORKSPACES__'

export class LastWorkspaceStorage {
  private readonly key: string
  private readonly storage: ObjectStorage

  constructor(storage: Storage, namespace?: string) {
    this.storage = createObjectStorage(storage)
    this.key = namespace
      ? `lastWorkspaceByUser.${namespace}`
      : 'lastWorkspaceByUser'
  }

  load = (userId: string) => {
    const item = this.storage.getItem(this.key)
    return item ? (item as LastWorkspace)[userId] : null
  }

  save = (workspaceId: string, userId: string) => {
    const lastWorkspace = { [userId]: workspaceId } as LastWorkspace
    const current = this.storage.getItem(this.key)

    if (!current) {
      this.storage.setItem(this.key, lastWorkspace)
      return
    }

    const updated = {
      ...(current as LastWorkspace),
      ...lastWorkspace,
    } as LastWorkspace

    this.storage.setItem(this.key, updated)
  }

  clear = (userId: string) => {
    const current = this.storage.getItem(this.key)
    if (current) {
      const updated = { ...(current as LastWorkspace) }
      delete updated[userId]
      this.storage.setItem(this.key, updated)
    }
  }
}
